import { render, staticRenderFns } from "./pruebascomercial.vue?vue&type=template&id=68e34b42&"
import script from "./pruebascomercial.vue?vue&type=script&lang=js&"
export * from "./pruebascomercial.vue?vue&type=script&lang=js&"
import style0 from "./pruebascomercial.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports